import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ContentSection from "sections/landingPage/ContentSection";

import styles from "./styles";

const InfoServices = () => {
  return (
    <Box position="relative">
      <ContentSection
        imageWidth={680}
        imageHeight={760}
        imagePath={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/uq.gif`}
        gridContainerProps={{ spacing: 6 }}
        title={
          <Typography
            component="h1"
            variant="h1"
            sx={{ textAlign: { xs: "center", lg: "left" } }}
          >
            What is Uniqly?
          </Typography>
        }
        text={
          <>
            <Typography
              paragraph
              sx={{ textAlign: { xs: "center", lg: "left" } }}
            >
              Uniqly helps brands turn physical products into interactive
              digital experiences. Using smart NFC tags, we let you link
              real-world items to custom online content — from videos and forms
              to campaigns and rewards. It’s a plug-and-play way to connect your
              merch, packaging, or giveaways with a measurable, updateable
              digital layer — no apps, no code, just instant engagement.
            </Typography>
          </>
        }
        imageBoxProps={{
          sx: styles.image,
        }}
        reverse
      />
    </Box>
  );
};

export default InfoServices;
